module.exports = __webpack_public_path__ + "img/paypal-logo.3aba082.png";